import React from 'react';
import { Container, Row } from 'shards-react';
import UserEmailInput from '../../../components/inputs/UserEmailInput';
import AccountNameOrIdInput from '../../../components/inputs/AccountNameOrIdInput';
import Errors from '../../../components/Errors';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import Table from './Table';
import ActionBar from '../../../components/common/ActionBar';

import PageTitle from '../../../components/PageTitle';
import Constants from '../../../data/Constants';
import { useShops } from '../../../hooks/queries/useShops';
import { useUrlState } from '../../../hooks/useUrlState';
import { positiveIntegerParam, stringParam } from '../../../utils/urlStateParams';

const inputs = [AccountNameOrIdInput, UserEmailInput];
const actions = [{ route: '/admin/shops/new', label: 'Crear nuevo shop' }];

const URL_STATE_CONFIG = {
  accountNameOrId: stringParam(),
  page: positiveIntegerParam(),
  userEmail: stringParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const filter = {
    accountNameOrId: urlState.accountNameOrId || undefined,
    userEmail: urlState.userEmail || undefined
  };
  const { shops, loading, error } = useShops(filter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      accountNameOrId: newFilter.accountNameOrId?.trim() || '',
      userEmail: newFilter.userEmail?.trim() || '',
      page: 1
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Shops" />
      </Row>
      <GenericSearchBar
        handleSubmit={onSubmit}
        inputs={inputs}
        loading={loading}
        values={urlState}
      />
      <ActionBar items={actions} />
      <Errors errors={error ? ['No se pudieron cargar los shops.'] : null} />
      <Table
        disableNext={shops.length < Constants.elementsPerPage}
        disablePrev={urlState.page === 1}
        loading={loading}
        onPageClick={handlePageClick}
        shops={shops}
      />
    </Container>
  );
};

export default List;
